var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwiterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 29.9999L23.6134 25.3876M23.6134 25.3876L19 18.9999H22.0547L25.3877 23.6133L30 18.9999M23.6134 25.3876L26.9442 29.9999H30L25.3866 23.6122",
    stroke: "#958060",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 24.4999C39 32.5083 32.5084 38.9999 24.5 38.9999C16.4917 38.9999 10 32.5083 10 24.4999C10 16.4916 16.4917 9.99992 24.5 9.99992C32.5084 9.99992 39 16.4916 39 24.4999Z",
    stroke: "#958060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiterIcon);
export default __webpack_public_path__ + "static/media/twiterIcon.ec2b845e53c3c2d443a3ac69c6f4109d.svg";
export { ForwardRef as ReactComponent };